import { MdxComponent, Prose } from '@it-incubator/mdx-components'
import { Typography, Cancel } from '@it-incubator/ui-kit'
import IconButton from '@mui/material/IconButton'
import { useGetMDXContentQuery } from 'features/videos/service/service'

import s from './MdxPreviewAndFileSelector.module.scss'

import { MdxFileSelector } from './MdxFileSelector'

type Props = {
  isEditing: boolean
  selectedMdx: string
  setSelectedMdx: (s: string) => void
}

export const MdxPreviewAndFileSelector = ({ isEditing, selectedMdx, setSelectedMdx }: Props) => {
  const { data: previewData } = useGetMDXContentQuery(
    {
      path: encodeURIComponent(selectedMdx),
    },
    { skip: !selectedMdx }
  )
  const clearSelectedFile = () => {
    setSelectedMdx('')
  }

  return (
    <div className={s.root}>
      {selectedMdx.length > 0 ? (
        <div className={s.selectedFileContainer}>
          <Typography.Body1>
            MDX файл: <strong>{selectedMdx}</strong>
          </Typography.Body1>

          {isEditing && (
            <IconButton
              onClick={clearSelectedFile}
              title={'Очистить выбор'}
              type={'button'}
              className={s.clearButton}
            >
              <Cancel />
            </IconButton>
          )}
        </div>
      ) : (
        <div>
          <Typography.Body2>Выбрать новый конспект:</Typography.Body2>
        </div>
      )}
      <div className={s.container}>
        {isEditing && <MdxFileSelector selectedMdx={selectedMdx} setSelectedMdx={setSelectedMdx} />}
        {!!previewData && selectedMdx.length > 0 && (
          <Prose>
            <MdxComponent code={previewData?.code ?? ''} />
          </Prose>
        )}
      </div>
    </div>
  )
}
